var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPreference(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.33333V10.6667H4V9.33333H0ZM0 1.33333V2.66667H6.66667V1.33333H0ZM6.66667 12V10.6667H12V9.33333H6.66667V8H5.33333V12H6.66667ZM2.66667 4V5.33333H0V6.66667H2.66667V8H4V4H2.66667ZM12 6.66667V5.33333H5.33333V6.66667H12ZM8 4H9.33333V2.66667H12V1.33333H9.33333V0H8V4Z",
    fill: "#959595"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPreference);
export default __webpack_public_path__ + "static/media/icon_preference.c741cfaac5e4e0f1f38c17f8ffc6f6ef.svg";
export { ForwardRef as ReactComponent };